@if (pillItems().length > 0) {
  <app-pills-overflow [items]="pillItems()" [maxRows]="3" [pillHeight]="24" [gapSize]="6">
    <ng-template #pillTemplate let-item>
      <div
        class="inline-flex w-full items-center overflow-hidden rounded-full border border-indigo-500 bg-indigo-50 px-2.5 py-0.5 transition-all dark:border-indigo-500 dark:bg-indigo-900">
        <p
          class="text-2xs truncate font-mono font-medium text-indigo-700 dark:text-indigo-200">
          {{ item.data }}
        </p>
      </div>
    </ng-template>
  </app-pills-overflow>
} @else {
  <span class="text-xs text-zinc-400">—</span>
}
